import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LegalMentionsComponent } from './legal-mentions/legal-mentions.component';
import { CguComponent } from './cgu/cgu.component';
import { CookiesManagementComponent } from './cookies-management/cookies-management.component';
import { PersonnalDataComponent } from './personnal-data/personnal-data.component';
import { AtInternetService } from 'src/app/services/at-internet.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {

  year: string;
  @Input() tag;

  constructor(
    private footerDialogRef: MatDialog,
    private atInternetService: AtInternetService
  ) { }

  ngOnInit(): void {
    var date = new Date();
    this.year = (date.getFullYear()).toString();
  }
  
  openPopin(type: string) {
    if (type === "cgu") {

      this.atInternetService.generatePage(this.tag, 'conditions_generales_CGU', 'conditions_generales_CGU');
      this.footerDialogRef.open(CguComponent, {
        panelClass: 'footer-dialog',
        data: {
          "title": "footer.CGU.title",
          "subtitle1": "footer.CGU.subtitle1",
          "label1": "footer.CGU.label1",
          "subtitle2": "footer.CGU.subtitle2",
          "label2": "footer.CGU.label2",
          "subtitle3": "footer.CGU.subtitle3",
          "label3": "footer.CGU.label3",
          "subtitle4": "footer.CGU.subtitle4",
          "subtitle4a": "footer.CGU.subtitle4a",
          "label4a": "footer.CGU.label4a",
          "subtitle4b": "footer.CGU.subtitle4b",
          "label4b": "footer.CGU.label4b",
          "subtitle4c": "footer.CGU.subtitle4c",
          "label4c": "footer.CGU.label4c",
          "subtitle5": "footer.CGU.subtitle5",
          "label5": "footer.CGU.label5",
          "subtitle6": "footer.CGU.subtitle6",
          "label6": "footer.CGU.label6",
          "subtitle7": "footer.CGU.subtitle7",
          "label7": "footer.CGU.label7",
          "subtitle8": "footer.CGU.subtitle8",
          "subtitle8a": "footer.CGU.subtitle8a",
          "label8a": "footer.CGU.label8a",
          "subtitle8b": "footer.CGU.subtitle8b",
          "label8b": "footer.CGU.label8b",
          "subtitle9": "footer.CGU.subtitle9",
          "label9": "footer.CGU.label9",
          "subtitle10": "footer.CGU.subtitle10",
          "label10": "footer.CGU.label10"
        }
      }
      );
    }
    if (type === "legal") {
      this.atInternetService.generatePage(this.tag, 'conditions_generales_ML', 'conditions_generales_ML');
      this.footerDialogRef.open(LegalMentionsComponent, {
        panelClass: 'footer-dialog',
        data: {
          "title": "footer.legal_notices.title",
          "subtitle1": "footer.legal_notices.subtitle1",
          "label1": "footer.legal_notices.label1",
          "subtitle2": "footer.legal_notices.subtitle2",
          "label2": "footer.legal_notices.label2",
          "subtitle3": "footer.legal_notices.subtitle3",
          "label3": "footer.legal_notices.label3"
        }
      }
      );
    }
    if (type === "cookies") {
      this.atInternetService.generatePage(this.tag, 'conditions_generales_PC', 'conditions_generales_PC');
      this.footerDialogRef.open(CookiesManagementComponent, {
        panelClass: 'footer-dialog',
        data: {
          "title": "footer.cookies.title",
          "subtitle1": "footer.cookies.subtitle1",
          "label11": "footer.cookies.label11",
          "label12": "footer.cookies.label12",
          "label13": "footer.cookies.label13",
          "subtitle2": "footer.cookies.subtitle2",
          "label2": "footer.cookies.label2",
          "subtitle3": "footer.cookies.subtitle3",
          "label3": "footer.cookies.label3",
          "subtitle4": "footer.cookies.subtitle4",
          "label4": "footer.cookies.label4",
          "subtitle5": "footer.cookies.subtitle5",
          "subtitle5a": "footer.cookies.subtitle5a",
          "label5a": "footer.cookies.label5a",
          "subtitle5b": "footer.cookies.subtitle5b",
          "label5b": "footer.cookies.label5b",
          "subtitle5c": "footer.cookies.subtitle5c",
          "label5c": "footer.cookies.label5c",
          "subtitle6": "footer.cookies.subtitle6",
          "label6": "footer.cookies.label6",
          "subtitle6a": "footer.cookies.subtitle6a",
          "tr1a": "footer.cookies.tr1a",
          "tr1b": "footer.cookies.tr1b",
          "tr1c": "footer.cookies.tr1c",
          "tr1d": "footer.cookies.tr1d",
          "tr1e": "footer.cookies.tr1e",
          "tr2a": "footer.cookies.tr2a",
          "tr2b": "footer.cookies.tr2b",
          "tr2c": "footer.cookies.tr2c",
          "tr2d": "footer.cookies.tr2d",
          "tr2e": "footer.cookies.tr2e",
          "subtitle6b": "footer.cookies.subtitle6b",
          "tr3a": "footer.cookies.tr3a",
          "tr3b": "footer.cookies.tr3b",
          "tr3c": "footer.cookies.tr3c",
          "tr3d": "footer.cookies.tr3d",
          "tr3d1": "footer.cookies.tr3d1",
          "tr3d2": "footer.cookies.tr3d2",
          "tr3e": "footer.cookies.tr3e",
          "subtitle6c": "footer.cookies.subtitle6c",
          "label6c1": "footer.cookies.label6c1",
          "label6c2": "footer.cookies.label6c2",
          "label6c3": "footer.cookies.label6c3",
          "tr4a": "footer.cookies.tr4a",
          "tr4b": "footer.cookies.tr4b",
          "tr4b1": "footer.cookies.tr4b1",
          "tr4c": "footer.cookies.tr4c",
          "tr4d": "footer.cookies.tr4d",
          "tr4e": "footer.cookies.tr4e",
          "tr5a": "footer.cookies.tr5a",
          "tr5b": "footer.cookies.tr5b",
          "tr5b1": "footer.cookies.tr5b1",
          "tr5c": "footer.cookies.tr5c",
          "tr5d": "footer.cookies.tr5d",
          "tr5e": "footer.cookies.tr5e",
          "tr6a": "footer.cookies.tr6a",
          "tr6b": "footer.cookies.tr6b",
          "tr6b1": "footer.cookies.tr6b1",
          "tr6c": "footer.cookies.tr6c",
          "tr6d": "footer.cookies.tr6d",
          "tr6e": "footer.cookies.tr6e",
          "tr7a": "footer.cookies.tr7a",
          "tr7b": "footer.cookies.tr7b",
          "tr7b1": "footer.cookies.tr7b1",
          "tr7c": "footer.cookies.tr7c",
          "tr7d": "footer.cookies.tr7d",
          "tr7d1": "footer.cookies.tr7d1",
          "tr7d2": "footer.cookies.tr7d2",
          "tr7d3": "footer.cookies.tr7d3",
          "tr7d4": "footer.cookies.tr7d4",
          "tr7e": "footer.cookies.tr7e",
          "tr8a": "footer.cookies.tr8a",
          "tr8b": "footer.cookies.tr8b",
          "tr8c": "footer.cookies.tr8c",
          "tr8d": "footer.cookies.tr8d",
          "tr8e": "footer.cookies.tr8e",
          "tr9a": "footer.cookies.tr9a",
          "tr9b": "footer.cookies.tr9b",
          "tr9c": "footer.cookies.tr9c",
          "tr9d": "footer.cookies.tr9d",
          "tr9e": "footer.cookies.tr9e",
          "subtitle7": "footer.cookies.subtitle7",
          "label7": "footer.cookies.label7",
          "subtitle8": "footer.cookies.subtitle8",
          "label8": "footer.cookies.label8",
        }
      });
    }
    if (type === "personnal") {
      this.atInternetService.generatePage(this.tag, 'conditions_generales_PDP', 'conditions_generales_PDP');
      this.footerDialogRef.open(PersonnalDataComponent, {
        panelClass: 'footer-dialog',
        data: {
          "title": "footer.personal_data.title",
          "label0": "footer.personal_data.label0",
          "subtitle1": "footer.personal_data.subtitle1",
          "label1": "footer.personal_data.label1",
          "subtitle2": "footer.personal_data.subtitle2",
          "label2": "footer.personal_data.label2",
          "subtitle3": "footer.personal_data.subtitle3",
          "label3": "footer.personal_data.label3",
          "subtitle4": "footer.personal_data.subtitle4",
          "label4a": "footer.personal_data.label4a",
          "label4aMailTo": "footer.personal_data.label4aMailTo",
          "label4aBis": "footer.personal_data.label4aBis"
        }
      });
    }
  }
}